import { Component } from '@angular/core';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss']
})
export class LogoutPageComponent {

  goToLogin() {
    window.location.href = window.location.origin + '/gpp';
  }

}
